export default {
  items: undefined,
  current: undefined
}
